import bp from '../core/bp.js';
import PlaylistEngine from './playlist.js';
import bannerCctr from './../components/messageBanner.js';
import styling from '../core/styling.js';
import { getView } from 'azure-maps-control';

class SequentialLoadEngine extends PlaylistEngine {
    constructor(args) {
        super(args)

        this.engines = this.engines.map((engine, i) => { return { engine, view: this.views[i] } });
        this.radrBoxesInfo = []
    }

    async initialDataLoad() {
        this.refreshAttackInfo();

        for (let i = 0; i < this.engines.length; i++)
        {
            const { engine, view, failed, initialized, dataLoaded } = this.engines[i];

            try 
            {
                await engine.initialDataLoad()
                    .then(
                        dataLoadIsOk => {                  
                            try {
                                const { map } = this.state;
                                if (map && !failed && !initialized) {
                                    engine.onMapReady(map);
                                    this.engines[i].initialized = true;
                                }

                                this.engines[i].dataLoaded = true
                            } catch (mapInitFailed) {
                                this.engines[i].failed = true;
                            }
                        },
                        failureDetails => {
                            this.engines[i].failed = true;
                            const name = engine?.options?.mapTitle ?? index;
                            console.error(`{Failed to initialize '${name}' view, skipping it. Details: ${failureDetails}`);
                            throw failureDetails
                        });

                    break;
            }
            catch
            {
                continue;
            }
        }
    };

    computeNextViewIndex(currentIndex = 0) {
        return (currentIndex + 1) % this.engines.length;
    }

    refreshBanner() {
        return bp.FetchJson('/api/banner')
            .then(bannerData => {
                const { enabled, title } = bannerData;
                const bannerInfo = bannerCctr();
                const { messageBanner } = bannerInfo;
                if (enabled) {
                    bannerInfo.setMessage(title);
                    styling.show(messageBanner);
                }
                else {
                    styling.hide(messageBanner);
                }
            });
    }

    onMapReady(freshMap) {
        this.state.map = freshMap;
        this.state.map.events.add('zoomend', (e) => { this.renderAttackInfo() })
        const enginesWithData = this.engines.filter(x => x.dataLoaded)

        if (!enginesWithData || enginesWithData.length == 0) throw new Error("No engine loaded successfuly")

        for (let i = 0; i < enginesWithData.length; i++)
        {   
            const engineInfo = enginesWithData[i]
            if (engineInfo.failed || engineInfo.initialized) {
                console.debug(`Engine ${index} bypassed init`);
            }
            try {
                engineInfo.engine.onMapReady(freshMap);
                engineInfo.initialized = true;

                this.startFromIndex = this.getViewIndex(engineInfo.view)

                break
            }
            catch (mapInitFailed) {
                engineInfo.failed = true;
                
            }
        }

        this.spinner.hide();

        const { statusBar } = this.controlPanel;
        const { element } = statusBar;
        statusBar.setStatus('');

        element.addEventListener('click', () => {
            if (this.timerPaused) {
                if (this.currentView === undefined)
                    this.trigger(this.startFromIndex);
                else {
                    this.swapTime = new Date();
                    this.swapTime.setSeconds((this.swapTime).getSeconds() - this.currentView.time + this.remainUponPauseSeconds);
                    const nextIndex = this.computeNextViewIndex(this.currentViewIndex);
                    this.trigger(nextIndex, this.remainUponPauseSeconds);
                }
                this.timerPaused = false;
            } else {
                this.timerPaused = true;

                clearInterval(this.trackSwitchTimeoutId);
                clearInterval(this.dataLoadingTimeoutId);

                this.remainUponPauseSeconds = this.currentViewSecondsRemain;
            }
        });

        if (this.views.length > 1) {
            setInterval(() => {
                if (this.stage.isPlaying() && this.currentView && !this.timerPaused) {
                    const currentIndex = this.currentViewIndex;
                    const nextIndex = this.computeNextViewIndex(currentIndex + this.skippedViewsCount);
                    let countdownText = '';
                    if (currentIndex == nextIndex) {
                        countdownText = this.engines.every(elem => elem.failed || elem.initialized) ? '' : 'Loading further sources...';
                    }
                    else if (nextIndex >= 0) {
                        const next = this.views[nextIndex];
                        const { state } = next.engine;

                        const remaining = Math.floor(this.currentView.time - this.secondsSinceSwap);
                        countdownText = remaining > 0 ? `Next : ${state.mapTitle} - ${remaining}s` : `Next : ${state.mapTitle}`;
                    }

                    statusBar.setStatus(countdownText);
                }
            }, 500);
        }

        setInterval(() => this.refreshBanner(), 20 * 1000);
        this.refreshBanner();

        setInterval(() => this.refreshAttackInfo(), 20 * 1000)
        this.refreshAttackInfo().then(() => this.renderAttackInfo())
    }

    refreshAttackInfo() {
        const {identifier} = this.state
        return bp.FetchJson(`/api/p/${identifier}/radr`)
            .then(radrData => {
                this.state.attackData = radrData

                this.views.forEach((view, index) => {
                    view.engine.state.attackData = radrData
                })
            })
    }

    renderAttackInfo() {
        if (this.timeInterval) {
            clearInterval(this.timeInterval)
        }

        for (let i = 0; i < this.radrBoxesInfo.length; i++) {
            this.radrBoxesInfo[i].popUp.close()

            this.state.map.layers.remove(this.radrBoxesInfo[i].lineLayer)
            this.state.map.layers.remove(this.radrBoxesInfo[i].symbolLayer)
            this.state.map.sources.remove(this.radrBoxesInfo[i].dataSource)

            delete this.radrBoxesInfo[i].lineLayer
            delete this.radrBoxesInfo[i].symbolLayer
            delete this.radrBoxesInfo[i].dataSource
            delete this.radrBoxesInfo[i].popUp
        }

        this.radrBoxesInfo = []

        if (!this.state.attackData || this.state.attackData.length == 0)
            return;
        
        const coordsForAttack = []

        const boxCoordinatesSpots = [
            [-37.265625, 55.379110],
            [-41.132813, 29.535230],
            [76.992188, -11.867351],
            [-121.289062, -2.108899],
            [-12.656250, -15.623037],
        ]

        for (let i = 0; i < Math.min(this.state.attackData.length, 3); i++) {
            const attack = this.state.attackData[i];
            const boxCoordinates = boxCoordinatesSpots[i]//this.computeBoxCoordinates(attack.geoLocations, this.state.map, i);
            coordsForAttack.push(boxCoordinates)
        }
        
        const yellows = [
            '#f4cc44',
            '#f5d156',
            '#f6d669',
            '#aa8e2f',
            '#FAFA33'
        ]
        //preventBoxCoordinatesOverlap(coordsForAttack)

        for (let i = 0; i < Math.min(this.state.attackData.length, 3); i++) {
            const attack = this.state.attackData[i];
            const boxCoordinates = coordsForAttack[i];
            const yellow = yellows[i]

            let radrInfo = {
                dataSource: new atlas.source.DataSource(),
                popUp: new atlas.Popup({
                    closeButton: false,
                    showPointer: false,
                })
            }

            radrInfo.lineLayer = new atlas.layer.LineLayer(radrInfo.dataSource, null, {
                strokeColor: yellow,
                strokeWidth: 6,
            })

            radrInfo.symbolLayer = new atlas.layer.BubbleLayer(radrInfo.dataSource, null, {
                radius: 9,
                color: yellow,
                strokeColor: yellow,
                strokeWidth: 1
            })

            this.state.map.sources.add(radrInfo.dataSource);

            this.state.map.layers.add(radrInfo.lineLayer);
            this.state.map.layers.add(radrInfo.symbolLayer);

            this.radrBoxesInfo.push(radrInfo)

            var attackLocations = attack.geoLocations?.map(loc => [Number(loc.longitude), Number(loc.latitude)]);
            //radrInfo.dataSource.clear()
            // Add connection points and lines
            if (attackLocations)
            {
                attackLocations.forEach(function (point) {
                    radrInfo.dataSource.add(new atlas.data.Feature(new atlas.data.Point(point)));
                    radrInfo.dataSource.add(new atlas.data.Feature(new atlas.data.LineString([boxCoordinates, point])));
                });
            }
    
            radrInfo.popUp.setOptions
            ({
                ...radrInfo.popUp.getOptions(),
                content: `
                <div style="width: 400px; height: 160px; background-color: orange; border: 6px solid ${yellow}; border-radius: 12px; display: flex; flex-direction: column; justify-content: space-around; align-items: center; padding: 16px; font-family: 'Source Sans Pro'; font-size: 1.1rem;">
                    <div style="margin: 0; color: black; border-radius: 8px;">Suspected ongoing attack</div>
                    <div style="margin: 0; color: black;">${attack.totalEvents} Events (${(attack.totalBlocks / attack.totalEvents * 100).toFixed(1)}% blocked)</div>
                    <div style="width: 160px; height: 16px; background-color: grey; position: relative; margin-top: 8px; margin-bottom: 8px;">
                        <div style="width: ${(attack.totalBlocks / attack.totalEvents * 100).toFixed(1)}%; height: 100%; background-color: #770912; position: absolute; left: 0; top: 0px;"></div>
                    </div>
                    <div style="margin: 0; color: black;">Time since detection: ${this.formatTimeSinceDetection(attack.detectionTime)}</div>
                    <div style="margin: 0; color: black;">Mitigation SLA: 12 Hrs</div>
                </div>
                `,
                position: boxCoordinates,
                pixelOffset: [0, 100],
                anchor: 'bottom'
            })
            
            radrInfo.popUp.open(this.state.map);
        }

        this.timeInterval = setInterval((radrInfo) => {
            for (let i = 0; i < this.radrBoxesInfo.length; i++) {
                const radrInfo = this.radrBoxesInfo[i]
                const attack = this.state.attackData[i];
                const boxCoordinates = coordsForAttack[i];
                const yellow = yellows[i]
                radrInfo.popUp.setOptions
                (
                    {
                        ...radrInfo.popUp.getOptions(),
                        content: `
                            <div style="width: 400px; height: 160px; background-color: orange; border: 6px solid ${yellow}; border-radius: 12px; display: flex; flex-direction: column; justify-content: space-around; align-items: center; padding: 16px; font-family: 'Source Sans Pro'; font-size: 1.1rem;">
                                <div style="margin: 0; color: black; border-radius: 8px;">Suspected ongoing attack</div>
                                <div style="margin: 0; color: black;">${attack.totalEvents} Events (${(attack.totalBlocks / attack.totalEvents * 100).toFixed(1)}% blocked)</div>
                                <div style="width: 160px; height: 16px; background-color: grey; position: relative; margin-top: 8px; margin-bottom: 8px;">
                                    <div style="width: ${(attack.totalBlocks / attack.totalEvents * 100).toFixed(1)}%; height: 100%; background-color: #770912; position: absolute; left: 0; top: 0px;"></div>
                                </div>
                                <div style="margin: 0; color: black;">Time since detection: ${this.formatTimeSinceDetection(attack.detectionTime)}</div>
                                <div style="margin: 0; color: black;">Mitigation SLA: 12 Hrs</div>
                            </div>
                            `,
                        position: boxCoordinates,
                        pixelOffset: [0, 100],
                        anchor: 'bottom'
                    }
                )
            }
        }, 1000)
    }

    preventBoxCoordinatesOverlap(coordsForAttack) {
        return
        if (coordsForAttack.length < 2) return;
        const boundingBox = mapInstance.getCamera().bounds;

        const clientWidth = window.innerWidth;
        const clientHeight = window.innerWidth;

        const widthConvertedValue = (boundingBox[2] - boundingBox[0]) / clientWidth;
        const heightConvertedValue = (boundingBox[3] - boundingBox[1]) / clientHeight;

        for (let i = 1; i < coordsForAttack.length; i++) {
            const previousCoord = coordsForAttack[i - 1]
            const coord = coordsForAttack[i]

            // NOTE: left neighbour
            if (coord[0] < previousCoord[0]) {
                if (previousCoord[0] - coord[0] < 300 * widthConvertedValue) {
                    coord[0] = previousCoord[0] - 300 * widthConvertedValue

                    if (coord[0] - 300 * widthConvertedValue > boundingBox[0]) {
                        coordsForAttack[i][0] = coordsForAttack[i][0] + 300 * widthConvertedValue
                    }
                    else 
                    {
                        coordsForAttack[i][0] = coordsForAttack[i][0] + 300 * widthConvertedValue
                    }
                }
            }
            else {
                if (coord[0] - previousCoord[0] < 300 * widthConvertedValue) {
                    coord[0] = previousCoord[0] + 300 * widthConvertedValue
                }
            }
            
        }
    }
    // Function to compute box coordinates
    computeBoxCoordinates(attackGeoLocations, mapInstance, index) {
        // Check if attackGeoLocations is valid and not empty
        if (!attackGeoLocations || attackGeoLocations.length === 0) {
            return [0, 0]; // Return a default coordinate if no valid locations
        }

        let totalLat = 0;
        let totalLon = 0;
        let count = 0;

        // Sum up all latitudes and longitudes
        for (const location of attackGeoLocations) {
            if (location.latitude && location.longitude) {
                totalLat += Number(location.latitude);
                totalLon += Number(location.longitude);
                count++;
            }
        }
        
        let centerLat = totalLat / count;
        let centerLon = totalLon / count;
        // Ensure the returned coordinates are at least 300px away from the center and within the map bounding box
        const pixelDistance = 200;
        
        const boundingBox = mapInstance.getCamera().bounds;

        const clientWidth = window.innerWidth;
        const clientHeight = window.innerWidth;

        const widthConvertedValue = (boundingBox[2] - boundingBox[0]) / clientWidth;
        const heightConvertedValue = (boundingBox[3] - boundingBox[1]) / clientHeight;

        const distanceLong = widthConvertedValue * pixelDistance;
        const distanceLat = heightConvertedValue * pixelDistance;

        let isCorrected = false;
        if (centerLon < boundingBox[0])
        {
            centerLon = boundingBox[0] + 450 * widthConvertedValue;
            isCorrected = true;
        }
        else if (centerLon > boundingBox[2]) {
            centerLon = boundingBox[2] - 150 * widthConvertedValue;
            isCorrected = true;
        }

        if (centerLat < (boundingBox[1] + 100 * heightConvertedValue)) {
            centerLat = boundingBox[1] + 450 * heightConvertedValue;
            isCorrected = true;
        }
        else if (centerLat > boundingBox[3]) {
            centerLat = boundingBox[3] - 450 * heightConvertedValue;
            isCorrected = true;
        }

        if (isCorrected)
        {
            return [centerLon, centerLat]
        }

        return [centerLon + distanceLong, centerLat + distanceLat]
    }

    millisecondsToHuman(ms) {
        const seconds = Math.floor((ms / 1000) % 60);
        const minutes = Math.floor((ms / 1000 / 60) % 60);
        const hours = Math.floor((ms  / 1000 / 3600 ) % 24)
      
        const humanized = [
          hours > 0 ? hours.toString() : '',
          minutes.toString().padStart(2, '0'),
          seconds.toString().padStart(2, '0'),
        ].filter(x => x.length > 0).join(':');
      
        return humanized;
      }

    formatTimeSinceDetection(detectionTime) {
        const now = (new Date()).getTime()

        const detectionDate = (new Date(detectionTime)).getTime()

        const difference = now - detectionDate

        return this.millisecondsToHuman(difference);
    }

    trigger(requestedIndex, secondsToPlay) {
        this.skippedViewsCount = 0
        if (this.stage.isPlaying()) {
            const readyEngines = this.engines.filter(engineInfo => engineInfo.initialized).length;
            if (readyEngines == 0) {
                this.haltMap();
                return;
            }                
            
            let nextViewIndex = this.computeNextViewIndex(requestedIndex);     
            let newView = this.views[requestedIndex];

            if (this.currentView === undefined) {
                this.swap(newView);
                this.trigger(nextViewIndex);
                this.renderAttackInfo()
            }
            else {
                const switchAfter = (secondsToPlay ?? this.currentView.time) * 1000;
                
                const dataFetchingOffsetSeconds = 5
                const dataFetchingOffsetMs = dataFetchingOffsetSeconds * 1000

                this.dataLoadingTimeoutId = setTimeout(async () => {
                    const loadingStarted = new Date()
                    do {
                        console.log('updating data for: '+ newView.options.mapTitle, new Date())
                        const isDataFetchSuccessful = await newView.engine.loadData(dataFetchingOffsetMs + 10 * 1000)
                        const loadingFinished = new Date()

                        if (isDataFetchSuccessful) {
                            if (!newView.engine.isMapInitialized) {
                                newView.engine.onMapReady(this.state.map);
                            }

                            const loadingTook = (loadingFinished - loadingStarted) / 1000;
                            let secondsRemains = (secondsToPlay ?? this.currentView.time) - ((secondsToPlay ?? this.currentView.time) - dataFetchingOffsetSeconds) - loadingTook;
                            if (secondsRemains < 0)
                                secondsRemains = 1;

                            if (!this.timerPaused) {
                                this.trackSwitchTimeoutId = setTimeout(() => {
                                    this.swap(newView);
                                    
                                    this.trigger(nextViewIndex);
                                    this.renderAttackInfo()
                                }, secondsRemains * 1000);
                            }

                            break;
                        }
                        else {
                            this.skippedViewsCount += 1
                            
                            newView = this.views[nextViewIndex]
                            nextViewIndex = this.computeNextViewIndex(nextViewIndex)
                        }
                    }
                    while(true);
                    
                }, switchAfter - dataFetchingOffsetMs);
            }
        }
    };
}

export default SequentialLoadEngine;